import PropTypes from 'prop-types';
import CertificationDetailsLink from './CertificationDetailsLink';
import CertificationBuyLink from './CertificationBuyLink';

const defaultProps = {};

const propTypes = {
  url: PropTypes.string.isRequired,
};

export default function CertificationActions({
  url,
  product,
}) {
  const hasProduct = product !== null;

  return (
    <div className="flex items-center w-full space-x-4">
      {!hasProduct && <CertificationDetailsLink url={url} />}
      {hasProduct && <CertificationBuyLink productId={product.databaseId} />}
    </div>
  );
}

CertificationActions.defaultProps = defaultProps;
CertificationActions.propTypes = propTypes;
